<!-- File: NavItems.vue -->
<template>
  <ul class="navigation">
    <li><router-link to="/">Beranda</router-link></li>
    <!-- <li><router-link to="/berita">Berita</router-link></li> -->

    <li class="menu-item-has-children">
      <a href="javascript:void(0);">Informasi</a>
      <ul class="sub-menu">
        <li><router-link to="/BeritaOPD">Berita</router-link></li>
        <li>
          <a href="https://konaweselatankab.go.id/agenda_pengumuman/pengumuman/list" target="_blank" rel="noopener noreferrer">
            Pengumuman
          </a>
        </li>
      </ul>
    </li>

    <li class="menu-item-has-children">
      <a href="javascript:void(0);">Profil</a>
      <ul class="sub-menu">
        <li><router-link to="/StrukturOrganisasi">Struktur Organisasi</router-link></li>
        <li><router-link to="/VisiMisi">Visi dan Misi</router-link></li>
        <li><router-link to="/TugasPokok">Tugas Pokok</router-link></li>
        <li><router-link to="/ProfilPegawai">Profil Pegawai</router-link></li>
        <!-- <li><router-link to="/KebijakanOPD">Kebijakan</router-link></li> -->
      </ul>
    </li>
    <li class="menu-item-has-children">
      <a href="javascript:void(0);">Unit Kerja</a>
      <ul class="sub-menu">
        <li><router-link to="/SekretariatOPD">Sekretariat</router-link></li>
        <li><router-link to="/BidangTangkap">Bidang Perikanan Tangkap</router-link></li>
        <li><router-link to="/BidangBudidaya">Bidang Perikanan Budidaya</router-link></li>
        <li><router-link to="/BidangDayasaing">Bidang Penguatan Daya Saing Sumberdaya Perairan</router-link></li>
      </ul>
    </li>

    <li class="menu-item-has-children">
      <a href="javascript:void(0);">Data Layanan</a>
      <ul class="sub-menu">
        <li><router-link to="/KelayakanPengelolaan">Kelayakan Pengelolaan</router-link></li>
        <li><router-link to="/SertifikasiBudidayaIkan">Sertifikasi Budidaya Ikan</router-link></li>
        <li><router-link to="/PembenihanIkan">Pembenihan Ikan</router-link></li>
        <li><router-link to="/AngkutIkan">Surat Izin Kapal Pengangkutan Ikan</router-link></li>
        <li><router-link to="/TangkapIkan">Surat Izin Penangkapan Ikan</router-link></li>
        <li><router-link to="/UsahaPerikanan">Surat Izin Usaha Perikanan</router-link></li>
      </ul>
    </li>

    <li class="menu-item-has-children">
      <a href="javascript:void(0);">Data Lainnya</a>
      <ul class="sub-menu">
        <li><router-link to="/DataUPTD">Data UPTD</router-link></li>
        <li><router-link to="/DataPeraturan">Data Peraturan</router-link></li>
      </ul>
    </li>
   

    <li class="menu-item-has-children">
      <a href="javascript:void(0);">Galeri</a>
      <ul class="sub-menu">
        <li><router-link to="/FotoOPD">Foto</router-link></li>
        <li><router-link to="/VideoOPD">Video</router-link></li>
      </ul>
    </li>


  </ul>
</template>
